import React from "react";
import Header from "../../components/Navbar";
import VerifyAccount from "../../components/Profile/VerifyAccount";

function VerifyPage() {
  return (
    <div>
      <Header />
      <VerifyAccount />
    </div>
  );
}

export default VerifyPage;
